// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as LucideReact from "lucide-react";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

let ArrowRightIcon = {};

let ArrowLeftIcon = {};

let ChevronDownIcon = {};

let MenuIcon = {};

let XIcon = {};

let StarIcon = {};

let InfoIcon = {};

function pad(n) {
  if (n < 10) {
    return "0" + String(n);
  } else {
    return String(n);
  }
}

function HomeAtoms$Eyebrow(props) {
  let className = props.className;
  let base = "text-[10px] tracking-[0.3em] uppercase text-gray-500 font-light";
  let cls = className !== undefined ? Core.cx(base, className) : Core.cx(base);
  return JsxRuntime.jsx("p", {
    children: props.children,
    className: cls
  });
}

let Eyebrow = {
  make: HomeAtoms$Eyebrow
};

function HomeAtoms$SerifHeading(props) {
  let className = props.className;
  let children = props.children;
  let __level = props.level;
  let __level_value = __level !== undefined ? __level : 2;
  let base = "font-serif font-extralight text-gray-900 tracking-tight leading-[1.05]";
  let cls = className !== undefined ? Core.cx(base, className) : Core.cx(base);
  switch (__level_value) {
    case 1 :
      return JsxRuntime.jsx("h1", {
        children: children,
        className: cls
      });
    case 3 :
      return JsxRuntime.jsx("h3", {
        children: children,
        className: cls
      });
    case 4 :
      return JsxRuntime.jsx("h4", {
        children: children,
        className: cls
      });
  }
  return JsxRuntime.jsx("h2", {
    children: children,
    className: cls
  });
}

let SerifHeading = {
  make: HomeAtoms$SerifHeading
};

function HomeAtoms$ArrowLink(props) {
  let className = props.className;
  let __tone = props.tone;
  let __tone_value = __tone !== undefined ? __tone : "dark";
  let toneCls = __tone_value === "light" ? "text-white border-white/80" : "text-gray-900 border-gray-900";
  let base = "inline-flex items-center gap-3 text-sm tracking-[0.2em] uppercase font-light border-b pb-1 hover:gap-5 transition-all duration-300";
  let cls = className !== undefined ? Core.cx(base, toneCls, className) : Core.cx(base, toneCls);
  return JsxRuntime.jsxs("a", {
    children: [
      props.label,
      JsxRuntime.jsx(LucideReact.ArrowRight, {
        size: 14,
        strokeWidth: 1.5
      })
    ],
    className: cls,
    href: props.href
  });
}

let ArrowLink = {
  make: HomeAtoms$ArrowLink
};

function HomeAtoms$Stars(props) {
  let rating = props.rating;
  let ratingText = String(rating);
  return JsxRuntime.jsx("div", {
    children: Belt_Array.map(Belt_Array.range(0, 4), i => {
      let cls = i < rating ? "fill-[#c9a14a]" : "fill-gray-200";
      return JsxRuntime.jsx(LucideReact.Star, {
        size: 13,
        strokeWidth: 0.0,
        className: cls
      }, String(i));
    }),
    "aria-label": t`${ratingText} out of 5 stars`,
    className: Core.cx("inline-flex", "items-center", "gap-0.5")
  });
}

let Stars = {
  make: HomeAtoms$Stars
};

function HomeAtoms$Wordmark(props) {
  let className = props.className;
  let base = "font-light tracking-wider text-xl";
  let cls = className !== undefined ? Core.cx(base, className) : Core.cx(base);
  return JsxRuntime.jsxs("span", {
    children: [
      "Insta",
      JsxRuntime.jsx("span", {
        children: "painting",
        className: Core.cx("font-medium")
      })
    ],
    className: cls
  });
}

let Wordmark = {
  make: HomeAtoms$Wordmark
};

export {
  ArrowRightIcon,
  ArrowLeftIcon,
  ChevronDownIcon,
  MenuIcon,
  XIcon,
  StarIcon,
  InfoIcon,
  pad,
  Eyebrow,
  SerifHeading,
  ArrowLink,
  Stars,
  Wordmark,
}
/*  Not a pure module */
